<template>
  <div v-show="isCategoryViewActiveLocal">
    <ul style="margin-top: 3px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="true"
                         size="large"
                         class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                         type="filled"
                         color="">
                Select a Category
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
      <li v-for="(_category, index) in categories" :key="index" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectCategory(_category)">
              {{ _category.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isCategoryViewActive: {
      required: false,
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    categories: {
      type: Array,
      required: false
    },
    isTeacher: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isCategoryViewActiveLocal: {
      get() {
        return this.isCategoryViewActive;
      }
    }
  },
  methods: {
    selectCategory(category) {
      var self = this;
      self.$emit("categorySelected", category);
    }
  }
};
</script>
